// extracted by mini-css-extract-plugin
module.exports = {"not_found":"not-found_not_found__k4Rm_"};